import React from 'react';
import ServiceComponent from './ServiceComponent';
import {Helmet} from 'react-helmet'

export default function ProduccionComponent() {

    const description = `Producimos todo tipo de mobiliario publicitario personalizado con los mejores diseños y acabados.`

  return (
    <>
    <Helmet>
      <title>Producción Publicitaria | Blue Group Marketing | Bolivia</title>
      <meta
        name="description"
        content="Producimos todo tipo de mobiliario publicitario personalizado: cabeceras de supermercados, letreros publicitarios, stands y góndolas en Bolivia."
      />
      <meta name="keywords" content="producción publicitaria, letreros publicitarios, stands, góndolas, cabeceras de supermercado, mobiliario publicitario, cochabamba, bolivia" />
      <meta name="robots" content="index, follow"/>
      <meta name="googlebot" content="index, follow"/>
      <link rel="canonical" href={`${process.env.FRONTENDURL}ProductionServices`} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Blue Group Marketing" />
      <meta property="og:url" content={`${process.env.FRONTENDURL}ProductionServices`} />
      <meta property="og:title" content="Producción Publicitaria | Blue Group Marketing | Bolivia" />
      <meta property="og:description" content="Producimos todo tipo de mobiliario publicitario personalizado: cabeceras de supermercados, letreros publicitarios, stands y góndolas en Bolivia." />
      <meta property="og:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Producción Publicitaria | Blue Group Marketing | Bolivia" />
      <meta name="twitter:description" content="Producimos todo tipo de mobiliario publicitario personalizado: cabeceras de supermercados, letreros publicitarios, stands y góndolas en Bolivia." />
      <meta name="twitter:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />
    </Helmet>
    <ServiceComponent description={description} service="PRODUCCIÓN" type="Produccion">
      <div className="mx-auto" style={{maxWidth:"1450px"}}>
      <ul className="text-3xl italic font-bold mt-20 text-center sm:text-left">
        <li className="text-bluegroup-100 mb-10">
          <img className="sm:inline w-32 mx-auto sm:mx-5" alt="Icono de Cabeceras de supermercados" src={require('../../assests/OurServices/Produccion/cabecera_icon.png')}/>Cabeceras de supermercados
        </li>
        <li className="text-bluegroup-300 mb-10">
          <img className="sm:inline w-32 mx-auto sm:mx-5" alt="Icono de Letreros publicitarios" src={require('../../assests/OurServices/Produccion/letrero_icon.png')}/>Letreros publicitarios
        </li>
        <li className="text-bluegroup-200 mb-10">
          <img className="sm:inline w-32 mx-auto sm:mx-5" alt="Icono de Stands publicitarios" src={require('../../assests/OurServices/Produccion/stand_icon.png')}/>Stands pequeños y grandes
        </li>
        <li className="text-bluegroup-800 mb-10">
          <img className="sm:inline w-32 mx-auto sm:mx-5" alt="Icono de Góndolas publicitarias" src={require('../../assests/OurServices/Produccion/gondola_icon.png')}/>Góndolas
        </li>
      </ul>
      </div>
    </ServiceComponent>
    </>
  );
}